// TODO(jaime): Resolve with ScopeFieldType in searchcriterion-defs.ts and the "scopes" used in the recording code.
// Which are all similar... but subtly different :/. Can't add imports from recording code to here either.
// Vice-versa might be possible. But we have the added semantic of "NoScope" for field validation here that does not
// exist with recording. So we have copy-pasta for now.
export enum FieldScope {
  NoScope = '',
  User = 'user',
  Event = 'evt',
  Page = 'page',
  Element = 'elem',
  Fsevt = 'fsevt',
}

export type SetFieldScope = Exclude<FieldScope, FieldScope.NoScope>;

export enum VarType {
  Str = 'str',
  Bool = 'bool',
  Int = 'int',
  Real = 'real',
  Date = 'date',
  Strs = 'strs',
  Bools = 'bools',
  Ints = 'ints',
  Reals = 'reals',
  Dates = 'dates',
}

export interface CustomField {
  scope: FieldScope;
  ident: string;
  varType: VarType;
}
